import * as React from 'react';

export interface IDropdownOption {
    id: string;
    display: string;
}

export interface IDropdownOptionProps {
    value: IDropdownOption;
    onDropdownSelect: () => void;
    name?: string;
}

export class DropdownOption extends React.Component<IDropdownOptionProps, any> {
    constructor(props) {
        super(props);
    }

    render() {
        const id = `${this.props.name}-${this.props.value.id}`;

        return (
            <option value={this.props.value.id}
                id={id}
                onClick={this.props.onDropdownSelect}>
                {this.props.value.display}
            </option>
        );
    }
};

export interface IDropdownProps {
    values: IDropdownOption[];
    selectedId?: string;
    display?: string;
    placeHolder?: string;
    onDropdownSelect: (id: string | number) => void;
    name?: string;
    cssClass?: string;
    id: string;
}

export class Dropdown extends React.Component<IDropdownProps, any> {
    static defaultProps = {
        placeHolder: '',
        display: '',
        selectedId: ''
    }

    renderOptions = (value, index) => {
        return <DropdownOption
            name={`${this.props.name}-index`}
            onDropdownSelect={this.forceUpdate}
            key={index}
            value={value} />
    }

    get values() {
        if (this.props.placeHolder) {
            return [Object.freeze({ id: "", display: this.props.placeHolder })].concat(this.props.values);
        }
        return this.props.values;
    }

    render() {
        return (
            <select
                id={this.props.id}
                onChange={(e) => this.props.onDropdownSelect((e.target as any).value)}
                value={this.props.selectedId}
                className={this.props.cssClass}>
                {this.values.map(this.renderOptions)}
            </select>
        )
    }
}